import { useCallback } from 'react'
import { authRepository } from '../api/auth-repository'

/**
 * Sign-out callback exposed as a hook so callers outside `features/auth/`
 * don't have to reach into the private `api/` layer.
 *
 * The hook itself stays trivial — it's the public surface for sign-out from
 * shared composers (`shared/components/app-shell.tsx`) and other features
 * (`features/admin/components/admin-shell.tsx`).
 */
export function useSignOut(): () => Promise<void> {
  return useCallback(() => authRepository.signOut(), [])
}
